__turbopack_context__.v({
  "animation": "limited-box-module-scss-module__DT3Cka__animation",
  "bottomContent": "limited-box-module-scss-module__DT3Cka__bottomContent",
  "button": "limited-box-module-scss-module__DT3Cka__button",
  "content": "limited-box-module-scss-module__DT3Cka__content",
  "fadeIn": "limited-box-module-scss-module__DT3Cka__fadeIn",
  "header": "limited-box-module-scss-module__DT3Cka__header",
  "icon": "limited-box-module-scss-module__DT3Cka__icon",
  "img": "limited-box-module-scss-module__DT3Cka__img",
  "info": "limited-box-module-scss-module__DT3Cka__info",
  "modal": "limited-box-module-scss-module__DT3Cka__modal",
  "modalContent": "limited-box-module-scss-module__DT3Cka__modalContent",
  "price": "limited-box-module-scss-module__DT3Cka__price",
  "root": "limited-box-module-scss-module__DT3Cka__root",
  "slideDown": "limited-box-module-scss-module__DT3Cka__slideDown",
  "slider": "limited-box-module-scss-module__DT3Cka__slider",
  "title": "limited-box-module-scss-module__DT3Cka__title",
});
